export type GTMEnvironment = {
  gtmId: string;
  auth: string;
  preview: string;
};

export const getGTMEnvironment = (): GTMEnvironment => {
  const gtmId: string = 'GTM-W7LTK46';

  if (import.meta.env.PROD) {
    return {
      gtmId,
      auth: 'UgO7A1CbNH051TAaNmvhsA',
      preview: 'env-1',
    };
  }
  if (import.meta.env.DEV) {
    return {
      gtmId,
      auth: 'n_V7VOoOsY7qAM-Yy4l1EQ',
      preview: 'env-3',
    };
  }

  // fallthrough to QA
  return {
    gtmId,
    auth: 'AmlqUnb5PCZFS_zOlYGkRQ',
    preview: 'env-4',
  };
};
